module.exports = __webpack_public_path__ + "static/media/dodge.d08d64a6.usdz";